import { useQuery } from '@tanstack/react-query';

import { InternalService, getRoomImagesByInternalService } from '~/services/AccommodationService';

const IMPORT_IMAGES_LIMIT = 40;

export const roomImagesByInternalServiceQueryKeys = {
  all: ['accommodation', 'room-images-by-internal-service'] as const,
  details: () => [...roomImagesByInternalServiceQueryKeys.all, 'detail'] as const,
  detail: (internalService: InternalService | undefined, internalServiceId: string | undefined) =>
    [...roomImagesByInternalServiceQueryKeys.details(), internalService, internalServiceId] as const,
};

export function useGetRoomImagesByInternalService({
  internalService,
  internalServiceId,
  enabled = true,
}: {
  internalService: InternalService | undefined;
  internalServiceId: string | undefined;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: roomImagesByInternalServiceQueryKeys.detail(internalService, internalServiceId),
    queryFn: async ({ signal }) => {
      if (!internalService || !internalServiceId) {
        throw new Error('internalService and internalServiceId are required');
      }

      const response = await getRoomImagesByInternalService({
        internalService,
        internalServiceId,
        limit: IMPORT_IMAGES_LIMIT,
        signal,
      });
      return response.result;
    },
    enabled: enabled && !!internalService && !!internalServiceId,
    retry: false,
  });
}
